import { Card } from "../../components/Card";
import type { PersonaRecord } from "../../api/personas";
import { formatAbsolute } from "../../lib/datetime";

interface ConsentCardProps {
  record: Pick<PersonaRecord, "consent_record_uri" | "consent_signed_at">;
}

function formatDate(iso: string | null): string {
  if (!iso) return "—";
  // Audit-grade timestamp — operators need the time, not just the date.
  return formatAbsolute(iso);
}

export function ConsentCard({ record }: ConsentCardProps) {
  const hasConsent = record.consent_record_uri !== null;

  return (
    <Card title="Consent record" accentColor={hasConsent ? "var(--success)" : "var(--error)"}>
      {hasConsent ? (
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          <div style={{ display: "flex", alignItems: "flex-start", gap: 8 }}>
            <span
              style={{
                fontSize: 9.5,
                fontWeight: 700,
                textTransform: "uppercase",
                letterSpacing: 0.6,
                color: "var(--text-muted)",
                width: 52,
                flexShrink: 0,
                paddingTop: 2,
              }}
            >
              URI
            </span>
            <span
              style={{
                fontFamily: "var(--font-mono)",
                fontSize: 10.5,
                color: "var(--text-secondary)",
                wordBreak: "break-all",
                lineHeight: 1.5,
              }}
            >
              {record.consent_record_uri}
            </span>
          </div>
          {record.consent_signed_at && (
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <span
                style={{
                  fontSize: 9.5,
                  fontWeight: 700,
                  textTransform: "uppercase",
                  letterSpacing: 0.6,
                  color: "var(--text-muted)",
                  width: 52,
                  flexShrink: 0,
                }}
              >
                Signed
              </span>
              <span
                style={{
                  fontSize: 11,
                  color: "var(--text-secondary)",
                  fontWeight: 600,
                }}
              >
                {formatDate(record.consent_signed_at)}
              </span>
            </div>
          )}
        </div>
      ) : (
        <div
          style={{
            fontSize: 11,
            color: "var(--text-muted)",
            fontStyle: "italic",
            lineHeight: 1.6,
          }}
        >
          No consent record on file. Required before activation.
        </div>
      )}
    </Card>
  );
}
